module.exports = __webpack_public_path__ + "static/img/7.78339c7c.png";